import React, { useEffect, useState } from 'react';
import { func, string } from 'prop-types';
import { ViewModule, FeaturedVideo, Burger } from '@magalu/stereo-ui-icons';
import { Container } from './list-display-type.styles';
const options = [{
  id: 'gallery',
  label: 'Galeria',
  icon: /*#__PURE__*/React.createElement(ViewModule, {
    height: "20",
    color: "#818181"
  })
}, {
  id: 'list',
  label: 'Lista',
  icon: /*#__PURE__*/React.createElement(Burger, {
    height: "18",
    color: "#818181"
  })
}, {
  id: 'miniature',
  label: 'Miniatura',
  icon: /*#__PURE__*/React.createElement(FeaturedVideo, {
    height: "16",
    color: "#818181"
  })
}];

function ListDisplayType({
  onChange,
  defaultMode
}) {
  const [option, setOption] = useState(options.find(o => o.id === defaultMode));
  const [index, setIndex] = useState(options.findIndex(o => o.id === defaultMode) + 1);

  function rotateIndex(idx) {
    if (idx >= options.length - 1) {
      setIndex(0);
      return;
    }

    const num = idx + 1;
    setIndex(num);
  }

  function handleClick() {
    rotateIndex(index);
    setOption(options[index]);
    const selectedOption = Object.assign({}, options[index]);
    delete selectedOption.icon;
    onChange(selectedOption);
  }

  useEffect(() => {
    if (option.id !== defaultMode) {
      const displayIndex = options.findIndex(o => o.id === defaultMode);
      setIndex(displayIndex + 1);
      setOption(options[displayIndex]);
      const selectedDisplay = Object.assign({}, options[displayIndex]);
      onChange(selectedDisplay);
    }
  }, [defaultMode]);
  return /*#__PURE__*/React.createElement(Container, {
    onClick: handleClick,
    p: 1,
    "data-testid": "display-type"
  }, option.label, " ", option.icon);
}

ListDisplayType.defaultProps = {
  defaultMode: 'gallery'
};
process.env.NODE_ENV !== "production" ? ListDisplayType.propTypes = {
  onChange: func.isRequired,
  defaultMode: string
} : void 0;
export default ListDisplayType;